<base-form-input
  label="Adresse de livraison / intervention"
  type="autocomplete"
  [controlName]="addressControlName"
  [items$]="deliveryAddress$"
  (autocompleteChange)="onAutocompleteChange($event)"
  (optionChange)="onAddressSelected($event)"
  displayProperty="label">
</base-form-input>

<base-form-input
  *ngIf="showEstablishmentPicker"
  label="Établissement de livraison"
  type="autocomplete"
  [controlName]="establishmentControlName"
  [items]="deliveryEstablishments"
  displayProperty="label">
</base-form-input>
